var collapsible_list_component_rtlignore_default = {
  "ltr": "rXAMV",
  "rtl": "p8g5j",
  "iconContainer": "E00OI",
  "icon": "CfKyu",
  "isExpanded": "JUR02",
  "listDimensions": "t10--"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
